import {
  RotationsplanAktiviertByStandortGruppenIdQuery,
  RotationsplanAktiviertByStandortGruppenIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { ROTATIONSPLAN_AKTIVIERT_BY_STANDORTGRUPPEN_ID } from '@/domain/navigation/features/navigation/hooks/useRotationsplanAktiviert/graphql/queries';

export function useRotationsplanAktiviert(standortGruppenId: string): {
  istAktiviert: boolean;
  error?: string;
} {
  const result = useSuspenseQuery<
    RotationsplanAktiviertByStandortGruppenIdQuery,
    RotationsplanAktiviertByStandortGruppenIdQueryVariables
  >(ROTATIONSPLAN_AKTIVIERT_BY_STANDORTGRUPPEN_ID, {
    variables: { standortGruppenId },
  });

  if (result.error) {
    Sentry.captureException(result.error.cause.message);
    return { istAktiviert: false };
  }

  return {
    istAktiviert:
      result.data.navigation_standortgruppeById.istRotationsplanAktiviert,
  };
}
